import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import style from "./style/navigationitem.scss";

const NavigationItem = ({ iconType, label, link, selected, navigateToRoute, id, classes = { root: "" } }) => {
    const onClickLink = (event) => {
        event.preventDefault();
        event.stopPropagation();

        navigateToRoute(link);
    };

    const navigationItemClasses = [style.navigation_item];

    if (selected) {
        navigationItemClasses.push(style.navigation_item__selected);
    }

    if (classes.root) {
        navigationItemClasses.push(classes.root);
    }

    return (
        <li
            className={navigationItemClasses.join(" ")}
            data-cy={`menu-${label}-button`}
            id={id}
            onClick={(event) => onClickLink(event)}
        >
            <a href={link}>
                {iconType ? <FontAwesomeIcon icon={iconType} /> : null}
                <span dangerouslySetInnerHTML={{ __html: label }} />
            </a>
        </li>
    );
};

export default NavigationItem;
